import { render, staticRenderFns } from "./todoDialog.vue?vue&type=template&id=5a52e735"
import script from "./todoDialog.vue?vue&type=script&lang=js"
export * from "./todoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports